<template>
  <div id="viewbook">
        <section class="py-5" v-if="notfound">
            Product not found.
        </section>
        <section class="py-5" v-else>
            <div class="container px-4 px-lg-5 my-5">
                <div class="row gx-4 gx-lg-5 align-items-center">
                    <div class="col-md-6"><img class="card-img-top mb-5 mb-md-0" :src="cover" alt="..." /></div>
                    <div class="col-md-6">
                        <h1 class="display-5 fw-bolder">{{title}}</h1>
                        <div class="fs-5 mb-5">
                            <!--<span class="text-decoration-line-through">$45.00</span>-->
                            <span>${{price}}</span>
                        </div>
                        <p class="lead text-start" v-for="p in description" v-bind:key="p">{{p}}</p>
                        <div class="d-flex">
                            <a :href="amazonhref" class="btn btn-outline-dark flex-shrink-0" type="button" v-if="amazonhref">
                                <i class="bi-cart-fill me-1"></i>
                                Buy on Amazon
                            </a>
                            <span v-else>Coming Soon!</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>

export default {
  name: 'ViewBook',
  mounted() {
    this.bookId = this.$route.params.bookId;
    this.fetchBookDetails();
  },
  data() {
    return {
        title: "",
        cover: "",
        bookId: "",
        description: "",
        price: "",
        notfound: false
    }
  },
  methods: {
    async fetchBookDetails() {
        const response = await fetch("/books/" + this.bookId + ".json");
        console.log(response.status);
        if(response.status == '404') {
            this.notfound = true;
            document.title = "Katie's Puzzles | Not Found";
        } else {

            const json = await response.json();

            this.title = json.title;
            this.description = json.description;
            this.cover = json.cover;
            this.price = json.price;
            this.amazonhref = json.amazonhref;

            document.title = "Katie's Puzzles | "+this.title;
        }
    }
  }
}
</script>

<style>

</style>
